import { render } from "./services.html?vue&type=template&id=c16536ba&scoped=true&external"
import script from "./services.js?vue&type=script&lang=js&external"
export * from "./services.js?vue&type=script&lang=js&external"

import "./YourServices.vue?vue&type=style&index=0&id=c16536ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16536ba"]])

export default __exports__